export default {"src":"https://www.alianca.com.br/vendor/_next/static/media/favicon_stage.311167e9.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};